import { createSelector } from "reselect"
import { get } from "lodash"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeEntityPermissionsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"
import { getRole } from "helpers/permissions/roles"
import { getIsPatFeatureEnabled } from "selectors/features"

export const getTeams = (_, props) => get(props, "teams.teams")

export const getTabs = createSelector(
  [getRoute, getPath, getIsOpPro, getRole, getIsPatFeatureEnabled],
  computeEntityPermissionsTabs,
)
